import { Box } from "@mui/material";
import styled from "styled-components";

export const PetDetailCardStyled = styled(Box)`
  background: var(--pure-white-color);
  padding: 20px;
  box-shadow: 0px 0px 4px 0px #f0f0f066;
  border-radius: 16px;
  display: flex;
  flex-basis: calc((100% - 40px) / 3);
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  &.opened {
    box-shadow: 0px 0px 0px 1px var(--royal-blue-color) inset;
    background: var(--light-blue-color);
    overflow-x: auto;
  }
  .top-part {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .name-and-type-gender {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .name {
        font-weight: 500;
        font-size: 18px;
        color: var(--coal-black-color);
      }
      .type-gender {
        font-weight: 400;
        font-size: 16px;
        color: var(--muted-gray-color);
      }
    }
    .age {
      font-weight: 500;
      font-size: 12px;
      color: var(--royal-blue-color);
      background: var(--light-blue-color);
      min-height: 38px;
      min-width: 100px;
      border-radius: 88px;
      padding: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
